import React from 'react';

import { tableLoaderVariants } from './tableStyles';

type TableLoaderProps = {
  rowsCount?: number;
  columnsCount: number;
};

const TableLoader: React.FC<TableLoaderProps> = ({
  rowsCount = 4,
  columnsCount,
}) => {
  const styles = tableLoaderVariants();

  return (
    <tbody className={styles.body()}>
      {Array.from({ length: rowsCount }).map((_item, index) => (
        <tr key={index} className={styles.row()}>
          <td
            colSpan={columnsCount}
            className={styles.cell({ isLast: index === rowsCount - 1 })}
          >
            <div className={styles.wrapper()}>
              <div className={styles.pulse()} />
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default React.memo(TableLoader);
